export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/czyc@2xw-af1ea14afd9b457fa92fd1b71eb9df29.webp";